import h from 'virtual-dom/h';

export default function FooterPersistentLinks(settings, singleLinkRenderer) {
    let _store = {};

    const initialize = (store) => _store = store;
    const getReducer = (     ) => state => state;
    const renderLink = (link ) => singleLinkRenderer.renderLink(link, settings, _store);

    function getRenderer() {
        return () => {
            let linkDivs = settings.FooterLinks.map(renderLink);

            if (settings.Footer && settings.Footer.separator) {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                linkDivs = interleaveSeparators(linkDivs, settings.Footer.separator);
            }

            const footerlink = h('div', { className: settings.classNames.footerLinks }, linkDivs);
            const disclaimerContent = h('div', { className: settings.classNames.disclaimerClassName }, settings.textConstants.disclaimer);
            return h('div', [disclaimerContent, h('br'), footerlink]);
        };
    }
    

    function interleaveSeparators(links, spec) {
        const { text, tag, props } = spec;
        const makeSep = () => (tag) ? h(tag, props || {}, text) : (text || null);
        return [].concat(...links.map(L => [makeSep(), L]).slice(1));
    }

    return { initialize, getReducer, getRenderer };
}


// WEBPACK FOOTER //
// ./components/renderers/nextit-footer-persistent-links.js